import { render, staticRenderFns } from "./group-editor.vue?vue&type=template&id=43739b62&"
import script from "./group-editor.vue?vue&type=script&lang=js&"
export * from "./group-editor.vue?vue&type=script&lang=js&"
import style0 from "./group-editor.vue?vue&type=style&index=0&id=43739b62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports